<template>
  <div
    class="mnemonic-badge"
    :class="[
      `mnemonic-badge-${variant}`,
      {
        'mnemonic-badge-urgent': urgent
      }
    ]"
    :title="urgent && 'Urgente'"
  >
    {{ label }}

    <svg-loader
      v-if="urgent"
      src="/static/images/icon-urgent-fast.svg"
    />
  </div>
</template>

<script>
export default {
  name: 'MnemonicBadge',
  props: {
    label: {
      type: String,
      required: true
    },
    variant: {
      type: String,
      default: 'pill' /** @note Options: pill, text, link */
    },
    urgent: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style lang="scss" scoped>
.mnemonic-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  border-radius: 2px;
  padding: 4px 6px;
  font-family: 'Exo 2';
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  text-transform: uppercase;

  &-pill {
    background-color: #4a4a4a;
    color: white;
  }

  &-link {
    text-decoration: underline;
    cursor: pointer;
  }

  &-urgent {
    padding: 1px 6px;
    background-color: #ffbf00;
    color: white;
    text-decoration: none;
  }

  .md-icon {
    min-width: auto;
    min-height: auto;
    width: 1.25rem;
    height: 1.25rem;
  }
}
</style>
